var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { useUniqueInlineId } from '@inline-svg-unique-id/react';
import * as React from "react";
function SvgHealth(props) {
  var _id = useUniqueInlineId();
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#".concat(_id, ")")
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.002 7.561c0 .094-.019.192-.019.294 0 3.54-4.59 7.507-7.866 9.792a1.953 1.953 0 01-2.241 0 45.705 45.705 0 01-2.249-1.705 26.21 26.21 0 01-1.598-1.396C2.85 12.5 1.034 10.096 1.034 7.859v-.294h-.032c0-1.233-.073-2.64.864-3.565 1.725-1.72 4.994-1.68 6.86-.113l1.28 1.088 1.278-1.088a4.681 4.681 0 013.857-1.022c.911.163 2.085.29 2.79.99.936.94 1.089 2.477 1.067 3.706h.004z",
    fill: "#BF5C5C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.002 6.796c0 .094-.019.192-.019.294 0 3.54-4.59 7.507-7.866 9.791a1.953 1.953 0 01-2.241 0 43.55 43.55 0 01-2.249-1.704A26.207 26.207 0 015.03 13.78C2.858 11.73 1.027 9.327 1.027 7.1v-.294h-.025A4.68 4.68 0 013.665 2.46a4.699 4.699 0 015.062.651L10.005 4.2l1.279-1.088a4.696 4.696 0 017.02 1.129 4.68 4.68 0 01.694 2.556h.004z",
    fill: "#F77777"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.14 2.1L5.03 13.777c-2.173-2.045-4.003-4.45-4.003-6.676v-.294h-.025A4.68 4.68 0 013.665 2.46a4.699 4.699 0 015.062.651L10.005 4.2l1.279-1.088A4.681 4.681 0 0115.14 2.1z",
    fill: "#FF8787"
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: _id
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(1 2)",
    d: "M0 0h18v16H0z"
  })))));
}
export default SvgHealth;